module.exports = __webpack_public_path__ + "img/phocuswire.d7ca8cd1.svg";